import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "src/redux/hooks";
import { setSendDataOnNewEntry } from "src/redux/slices/generatorSlice";

export function resolveSavedEntryId(
  result: any,
  idType: "lbeid" | "partid" | "meid",
) {
  return result?.[idType] ?? result?.lbeid ?? result?.partid ?? result?.meid;
}

export const useEntryNavigation = (
  logbookId: string | undefined,
  entryIdType: "lbeid" | "partid" | "meid",
) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const navigateToSavedEntry = useCallback(
    (result: any) => {
      if (!logbookId) return;
      const savedId = resolveSavedEntryId(result, entryIdType);
      if (!savedId) return;

      dispatch(setSendDataOnNewEntry(true));
      navigate(`/logbook/${logbookId}/${entryIdType}/${savedId}`, {
        replace: true,
      });
    },
    [dispatch, entryIdType, logbookId, navigate],
  );

  return { navigateToSavedEntry };
};
